import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=b188afaa&scoped=true&"
import script from "./Destination.vue?vue&type=script&lang=js&"
export * from "./Destination.vue?vue&type=script&lang=js&"
import style0 from "./Destination.vue?vue&type=style&index=0&id=b188afaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b188afaa",
  null
  
)

export default component.exports